import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    buttons: {
        capitalize: false,
    },
    theme: {
        themes: {
            light: {
                primary: '#2537B4'
            }
        },
    },
});
